import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";


export default class FinishRoundRequest implements IRequestBuilder {
    get method() {
        return "POST";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/gamefinished";
     }
  
    get requestData() {
        GameModel.incrementRestoreVersion();
        let data = {
            g: Configs.vendorServer.gameId,
            restoreVersion: GameModel.restoreVersion,
            sid: GameModel.sessionID
        };
  
      // console.log("[Requests] Finish Round", data);
        return data;
    }
  }